module.exports = __webpack_public_path__ + "static/media/restore-k-10.fcdf3ea7.png";